export default __webpack_public_path__ + "static/media/drunkwhitelotusschool.63a614b3.jpg";